module.exports = new __parcel__URL__("field-schemes-app-skeleton.tpl.0f9ec3c8.svg").toString();